import React from 'react'
import { connect } from 'react-redux'
import Downshift from 'downshift'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import Portal from 'components/Portal/Portal'

class MultiComplete extends React.Component {
  updateMenuOnNextValueChange = false;
  componentDidUpdate = prevProps => {
    if (
      this.updateMenuOnNextValueChange &&
      prevProps.value.length !== this.props.value.length &&
      this.menu &&
      this.menu.updateMenuPosition
    ) {
      this.menu.updateMenuPosition()
    }
  }
  componentDidMount() {
    this.props.onChange(this.props.value.filter(value => this.props.options.some(option => option.value === value)))
  }
  addSelection = options => {
    this.props.onChange([...this.props.value, options.value])
  }
  remove = i => {
    this.props.onChange([...this.props.value.slice(0, i), ...this.props.value.slice(i + 1)])
  }
  handleEnterKey = e => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }
  stateReducer = (dstate, changes) => {
    switch (changes.type) {
      case Downshift.stateChangeTypes.clickItem:
        if(this.props.leaveOpenOnSelect){
          this.updateMenuOnNextValueChange = true;
          return {
            ...changes,
            isOpen: true
          }
        }
        return changes;
      default:
        return changes
    }
  }
  render() {
    const {
      value,
      options,
      width,
      label,
      placeholder,
      required,
      maxRows,
      // fieldId,
      disabled,
      ariaLabel,
      isMobile
    } = this.props
    return (
      <div>
        <Downshift onChange={this.addSelection} stateReducer={this.stateReducer} itemToString={() => ''}>
          {({
            getInputProps,
            getItemProps,
            getLabelProps,
            getMenuProps,
            getToggleButtonProps,
            isOpen,
            inputValue,
            highlightedIndex,
            selectedItem
          }) => {
            return (
              <div className="multi-complete">
                <label className="field-label" {...getLabelProps()}>
                  {label}
                  {required && label !== '' && (
                    <span className="required" aria-hidden={true}>
                      *
                    </span>
                  )}
                </label>
                {value.length > 0 && (
                  <div className="tags-wrapper">
                    {value.map((v, i) => (
                      <Tag
                        onClick={e => {
                          this.remove(i)
                        }}
                        key={`${v}${i}`}
                        disabled={this.props.disabled}
                      >
                        {(options.find(o => o.value === v) || {}).label || v}
                      </Tag>
                    ))}
                  </div>
                )}
                {(!maxRows || value.length < maxRows) && (
                  <div className="multi-input-wrapper" style={{ width }}>
                    <input
                      type="text"
                      {...getInputProps({
                        ref: r => (this.inputRef = r),
                        placeholder,
                        onKeyDown: this.handleEnterKey,
                        disabled
                      })}
                      aria-label={ariaLabel}
                    />
                    <button
                      {...getToggleButtonProps({
                        className: 'menu-button ' + (isOpen ? 'open' : ''),
                        disabled
                      })}
                    >
                      <CaretDownIcon />
                    </button>
                  </div>
                )}
                <Portal isOpened>
                  <Menu
                    isOpen={isOpen}
                    getMenuProps={getMenuProps}
                    getItemProps={getItemProps}
                    inputValue={inputValue}
                    highlightedIndex={highlightedIndex}
                    options={options.filter(o => !value.includes(o.value))}
                    isMobile={isMobile}
                    getInputRef={() => this.inputRef}
                    ref={r => this.menu = r}
                  />
                </Portal>
              </div>
            )
          }}
        </Downshift>
      </div>
    )
  }
}
export default connect(
  state => ({
    isMobile: state.app.isMobile
  })
)(MultiComplete)

class Menu extends React.Component {
  state = {
    isOpen: false,
    anchor: null
  }
  componentDidUpdate = prevProps => {
    if (this.props.isOpen !== prevProps.isOpen) {
      if(this.props.isOpen){
        this.attachScrollListener()
      }else{
        this.detachScrollListener()
      }
      this.setState({ isOpen: this.props.isOpen, anchor: this.getAnchor() })
    }
  }
  componentWillUnmount = () => this.detachScrollListener()
  attachScrollListener = () => {
    const scrollWrapper = this.props.isMobile ? window : document.getElementById('wizard-body-scroll-container')
    if(scrollWrapper){
      this.scrollWrapper = scrollWrapper
      scrollWrapper.addEventListener('scroll', this.updateMenuPosition)
    }
  }
  updateMenuPosition = () => this.setState({anchor: this.getAnchor()})
  detachScrollListener = () => {
    if(this.scrollWrapper){
      this.scrollWrapper.removeEventListener('scroll', this.updateMenuPosition)
    }
  }
  getAnchor = () => this.props.getInputRef().getBoundingClientRect()
  calculateHeight = () =>
    this.state.anchor.bottom + 240 > window.innerHeight - 50
      ? 240 - (this.state.anchor.bottom + 240 - window.innerHeight) - 50
      : 240
  render() {
    const { getMenuProps, getItemProps, inputValue, options, highlightedIndex } = this.props
    return (
      this.state.isOpen && (
        <ul
          {...getMenuProps({
            className: 'multi-complete-menu',
            style: {
              left: this.state.anchor.left + 3,
              top: this.state.anchor.bottom - 4,
              minWidth: this.state.anchor.width - 6,
              maxHeight: this.calculateHeight()
            }
          })}
        >
          {options
            .filter(opt => opt.label.toLowerCase().includes(inputValue.toLowerCase()))
            .map((opt, i) => (
              <li
                {...getItemProps({
                  item: opt,
                  key: opt.value,
                  className: highlightedIndex === i ? 'highlighted' : ''
                })}
              >
                {opt.label}
              </li>
            ))}
        </ul>
      )
    )
  }
}

const Tag = ({ children, onClick, disabled }) => (
  <div className="multi-tag">
    <button
      className="remove-button"
      onClick={onClick}
      aria-label={`Unselect ${children.toString()}`}
      disabled={disabled}
    >
      ✕
    </button>
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/MultiComplete.js